<script>
  import ListaItens from './FormListaItens.vue';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';

  export default {
    components: { ListaItens, Cabecalho },
    props: {
      importacao: Object,
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
      }
    },
    methods: {
      codigoImportacao(idSolicitacaoImportacao) {
        return 'MI-' + idSolicitacaoImportacao;
      },
    },
    mounted() {
      this.$root.tituloDaPagina = 'Importação - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'compra.importacao';

      this.$events.on('botaoAcao', function () {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">

              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Importação - Relatório'"></cabecalho>

                <h3 class="m-t-none m-b">Processo</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>Número</dt>
                    <dd>{{ codigoImportacao(importacao.idSolicitacaoImportacao) }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Projeto</dt>
                    <dd>{{ importacao.projeto ? importacao.projeto.nomeProjeto : '' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Coordenador</dt>
                    <dd>{{ importacao.coordenador ? importacao.coordenador : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Instituição</dt>
                    <dd>{{ importacao.institutoProcesso || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>CNPJ</dt>
                    <dd>{{ importacao.cnpjExecutora || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-4">
                    <dt>Credenciamento CNPQ</dt>
                    <dd>{{ importacao.credenciamentoCNPQ || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Departamento</dt>
                    <dd>{{ importacao.departamento || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Laboratório</dt>
                    <dd>{{ importacao.laboratorio || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Título do Projeto</dt>
                    <dd>{{ importacao.tituloProjeto || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Descrição do projeto</dt>
                    <dd>{{ importacao.descricaoImportacaoProjeto || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Objetivo</dt>
                    <dd>{{ importacao.descricaoImportacaoFinanciador || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados Local de Entrega e de doação de Bens e Equipamentos</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>CEP</dt>
                    <dd>{{ importacao.cepLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ importacao.enderecoLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ importacao.numeroLocalAlocado || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>Complemento</dt>
                    <dd>{{ importacao.complementoLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Bairro</dt>
                    <dd>{{ importacao.bairroLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Cidade</dt>
                    <dd>{{ importacao.cidadeLocalAlocado || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Estado</dt>
                    <dd>{{ importacao.estadoLocalAlocado || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Proforma invoice</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Data da Proforma</dt>
                    <dd>{{ importacao.dataProforma }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>N° Proforma Invoice</dt>
                    <dd>{{ importacao.numeroProformaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Validade Proposta</dt>
                    <dd>{{ importacao.validadeProposta || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados do Exportador</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-5">
                    <dt>Nome exportador</dt>
                    <dd>{{ importacao.nomeExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Email</dt>
                    <dd>{{ importacao.emailExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Site</dt>
                    <dd>{{ importacao.siteExportador || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>Telefone 1</dt>
                    <dd>{{ importacao.telefone1Exportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 2</dt>
                    <dd>{{ importacao.telefone2Exportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-8">
                    <dt>Endereço</dt>
                    <dd>{{ importacao.enderecoExportador || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-2">
                    <dt>ZIP Code</dt>
                    <dd>{{ importacao.zipCodeExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Cidade</dt>
                    <dd>{{ importacao.cidadeExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ importacao.estadoExportador || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>País</dt>
                    <dd>{{ importacao.paisExportador || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Representante no Brasil</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Nome empresa</dt>
                    <dd>{{ importacao.nomeEmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Contato empresa</dt>
                    <dd>{{ importacao.contatoEmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Email</dt>
                    <dd>{{ importacao.emailEmpresaInvoice || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Site</dt>
                    <dd>{{ importacao.siteEmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 1</dt>
                    <dd>{{ importacao.telefone1EmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Telefone 2</dt>
                    <dd>{{ importacao.telefone2EmpresaInvoice || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>País</dt>
                    <dd>{{ importacao.paisEmpresaInvoice || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Condições Gerais das compras (INCOTERMS)</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Forma Pagamento</dt>
                    <dd>{{ importacao.importacaoFormaPagamento ? importacao.importacaoFormaPagamento.formaPagamento : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Previsão de Entrega</dt>
                    <dd>{{ importacao.importacaoPrevisaoEntrega ? importacao.importacaoPrevisaoEntrega.previsaoEntrega : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>INCOTERM</dt>
                    <dd>{{ importacao.importacaoIncoterm ? importacao.importacaoIncoterm.incoterm : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Moeda</dt>
                    <dd>{{ importacao.importacaoMoeda ? importacao.importacaoMoeda.nomeMoeda : '---' }}</dd>
                  </dl>

                  <dl class="col-xs-2">
                    <dt>Cotação estimada</dt>
                    <dd>{{ importacao.solicitacaoImportacao ? importacao.solicitacaoImportacao.cotacaoEstimada : '1,0000' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Outras Condições Gerais das Compras (INCOTERMS)</dt>
                    <dd>{{ importacao.outrasCondicoesCompra || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t m-b">Dados Bancários Exportador</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Instituição Financeira</dt>
                    <dd>{{ importacao.instituicaoFinanceira || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>Endereço da Agência</dt>
                    <dd>{{ importacao.enderecoAgencia || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número Agência</dt>
                    <dd>{{ importacao.numeroAgencia || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número da Conta</dt>
                    <dd>{{ importacao.numeroConta || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>IBAN</dt>
                    <dd>{{ importacao.iban || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-5">
                    <dt>SWFIT Code</dt>
                    <dd>{{ importacao.swfitCode || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Informações Complementares</dt>
                    <dd>{{ importacao.informacoesComplementares || '---' }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                 <lista-itens :itens-importacao="importacao.itensImportacao" :relatorio="true" :importacao="importacao"></lista-itens>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/importacao/componentes/compartilhado/RelatorioImportacao.vue